import { render, staticRenderFns } from "./base-accordion.vue?vue&type=template&id=5424345e"
import script from "./base-accordion.vue?vue&type=script&lang=ts"
export * from "./base-accordion.vue?vue&type=script&lang=ts"
import style0 from "./base-accordion.vue?vue&type=style&index=0&id=5424345e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports